/**
 * Public Signal Approval Receipt V1 - Draft Validator
 * 
 * Validates public signal drafts before approval.
 * 
 * BOUNDARIES:
 * - Advisory only: no execution authority
 * - Deterministic output only
 * - Fail closed on invalid drafts
 * - No mutation of inputs
 */

import { PublicSignalDraftV1 } from '../publicSignalDraft';
import { DraftValidationResult } from './types';
import { validateDraftForDisclosureLevel } from '../publicSignalDraft/publicSignalDraftGenerator';

/**
 * Validate public signal draft
 */
export function validateDraft(draft: PublicSignalDraftV1): DraftValidationResult {
  // Check approvalRequired is true
  if (!draft.approvalRequired) {
    return {
      valid: false,
      reason: 'Draft must have approvalRequired set to true',
    };
  }

  // Check executable is false
  if (draft.executable) {
    return {
      valid: false,
      reason: 'Draft must have executable set to false',
    };
  }

  // Validate for disclosure level
  const validation = validateDraftForDisclosureLevel(draft, draft.disclosureLevel);
  if (!validation.valid) {
    return {
      valid: false,
      reason: validation.reason || 'Draft validation failed',
    };
  }

  return {
    valid: true,
  };
}
